// src/components/SelectedProgramHeader.js
import React from 'react';
import { useProgram } from '../context/ProgramContext';
import apiClient from '../api'; // To construct logo URLs
import defaultProgramIcon from '../assets/icons/default-program-icon.svg';
import '../styles/SelectedProgramHeader.css'; // We will create this CSS file

const SelectedProgramHeader = () => {
    const { selectedProgram } = useProgram();

    if (!selectedProgram) {
        return null; // Don't render anything if no program is selected
    }

    let iconSrc = defaultProgramIcon;
    if (selectedProgram.logo_url) {
        if (selectedProgram.logo_url.startsWith('http')) {
            iconSrc = selectedProgram.logo_url;
        } else {
            // Ensure apiClient.defaults.baseURL does not end with a slash while logo_url starts with one
            const base = apiClient.defaults.baseURL.endsWith('/') ? apiClient.defaults.baseURL.slice(0, -1) : apiClient.defaults.baseURL;
            const logoPath = selectedProgram.logo_url.startsWith('/') ? selectedProgram.logo_url : `/${selectedProgram.logo_url}`;
            iconSrc = `${base}${logoPath}`;
        }
    }

    return (
        <div className="selected-program-header">
            <img src={iconSrc} alt={`${selectedProgram.name} Logo`} className="selected-program-icon" />
            <span className="selected-program-name">{selectedProgram.name}</span>
            <span className="selected-program-short-name">({selectedProgram.short_name})</span>
        </div>
    );
};

export default SelectedProgramHeader;